attribute vec2 a_position;

varying highp vec2 v_texturecoord;

const vec2 scale = vec2(0.5, 0.5);

void main(void) {
  v_texturecoord  = (a_position * scale + scale);
  v_texturecoord.y = 1.0 - v_texturecoord.y;
  gl_Position = vec4(a_position, 0, 1);
}
